import React from 'react'
import { connect } from 'react-redux'

const withRole = (Component, allowed, ElseComponent) => {
  class RoleBasedComponent extends React.Component {
    render() {
      if (this.props.profile && allowed.filter((n) => this.props.profile.roles.includes(n)).length) {
        return (<Component
          {...this.props}
        />)
      } else {
        if (ElseComponent) {
          return (<ElseComponent
            {...this.props}
          />)
        } else {
          return null;
        }
      }

    }
  }
  const mapStateToProps = (state) => ({
    profile: state.profileReducer.profile,
    ...state,
  })

  return connect(mapStateToProps)(RoleBasedComponent)
}

export default withRole;



// WEBPACK FOOTER //
// ./src/components/hoc/role/index.js